function required(key, value) {
  if (typeof value !== "string") {
    throw new Error(`Environment variable ${key} is not defined`)
  }

  return value
}

export default {
  appName: process.env.VUE_APP_NAME ?? "Adveroo",
  apiUrl: required("VUE_APP_API_URL", process.env.VUE_APP_API_URL),
  clientId: required("VUE_APP_CLIENT_ID", process.env.VUE_APP_CLIENT_ID),
  isDev: process.env.NODE_ENV !== "production",
}
